var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3, _path4, _path5, _circle9, _circle10, _circle11, _circle12, _path6, _circle13, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotifHeader1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 264,
    viewBox: "0 0 144 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 156,
    r: 12,
    fill: "#143162"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 180,
    r: 12,
    fill: "#0052A4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 228,
    r: 12,
    fill: "#0052A4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 204,
    r: 12,
    fill: "#66DDC0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 180,
    r: 12,
    fill: "#0052A4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 228,
    r: 2,
    fill: "#66DDC0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 156,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 108,
    r: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 168C29.3726 168 24 162.627 24 156C24 149.373 29.3726 144 36 144L60 144C66.6274 144 72 149.373 72 156C72 162.627 66.6274 168 60 168L36 168Z",
    fill: "#66DDC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 240C101.373 240 96 234.627 96 228C96 221.373 101.373 216 108 216L132 216C138.627 216 144 221.373 144 228C144 234.627 138.627 240 132 240L108 240Z",
    fill: "#66DDC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 264C5.37258 264 -2.34843e-07 258.627 -5.24537e-07 252C-8.1423e-07 245.373 5.37258 240 12 240L36 240C42.6274 240 48 245.373 48 252C48 258.627 42.6274 264 36 264L12 264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 204C72 210.627 66.6274 216 60 216C53.3726 216 48 210.627 48 204L48 180C48 173.373 53.3726 168 60 168C66.6274 168 72 173.373 72 180L72 204Z",
    fill: "#143162"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 192L48 192L48 180C48 173.373 53.3726 168 60 168C66.6274 168 72 173.373 72 180L72 192Z",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#143162"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 36,
    r: 12,
    fill: "#0052A4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 84,
    r: 12,
    fill: "#0052A4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 60,
    r: 12,
    fill: "#66DDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24C29.3726 24 24 18.6274 24 12C24 5.37258 29.3726 2.34843e-07 36 5.24537e-07L60 1.57361e-06C66.6274 1.8633e-06 72 5.37259 72 12C72 18.6274 66.6274 24 60 24L36 24Z",
    fill: "#66DDC0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 108,
    r: 12,
    fill: "#0052A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60C72 66.6274 66.6274 72 60 72C53.3726 72 48 66.6274 48 60V36C48 29.3726 53.3726 24 60 24C66.6274 24 72 29.3726 72 36V60Z",
    fill: "#143162"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72 48H48V36C48 29.3726 53.3726 24 60 24C66.6274 24 72 29.3726 72 36V48Z",
    fill: "#DDE2E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifHeader1);
export default __webpack_public_path__ + "static/media/motif-header-1.37b2f7b17a25caeecce13b9cf44c5b1f.svg";
export { ForwardRef as ReactComponent };